import create from 'zustand';
export type SlideData = {
  slideType: string;
  type: string;
  data: any;
  image: any | null;
  overallPerSelected: any;
  controlPerSelected: any;
  treatmentPerSelected: any;
  baselinePerSelected: any;
  progressPerSelected: any;
  diffPerSelected: any;
  showLables: any;
};
type StoreType = {
  selectedSlideType: string;
  slidesData: SlideData[];
  saveData: boolean | null;
  isDataReverse: boolean;
  setSelectedSlideType: (type: string) => void;
  setSaveData: (param: any) => void;
  setSlideData: (
    data: any,
    slideType: string,
    type: string,
    overallPerSelected?: boolean,
    controlPerSelected?: boolean,
    treatmentPerSelected?: boolean,
    baselinePerSelected?: boolean,
    progressPerSelected?: boolean,
    diffPerSelected?: boolean,
    showLables?: boolean
  ) => void;
  setSlideDataArray: (data: any) => void;
  resetStore: () => void;
  toggleReverseData: () => void;
};
export const useSlideContainerStore = create<StoreType>((set) => {
  return {
    selectedSlideType: 'Subject Wise',
    slidesData: [],
    saveData: null,
    isDataReverse: false,

    setSelectedSlideType: (type: string) => {
      set(() => ({
        selectedSlideType: type,
      }));
    },
    setSaveData: (param: any) => {
      set(() => ({
        saveData: param,
      }));
    },
    setSlideData: (
      data: any,
      slideType: string,
      type: string,
      overallPerSelected?: boolean,
      controlPerSelected?: boolean,
      treatmentPerSelected?: boolean,
      baselinePerSelected?: boolean,
      progressPerSelected?: boolean,
      diffPerSelected?: boolean,
      showLables?: boolean
    ) => {
      set((state) => {
        if (state.slidesData.length > 0) {
          let existingData = state.slidesData;
          existingData.push({
            slideType: slideType,
            type: type,
            data: data,
            image: null,
            overallPerSelected,
            controlPerSelected,
            treatmentPerSelected,
            baselinePerSelected,
            progressPerSelected,
            diffPerSelected,
            showLables,
          });
          return { slidesData: existingData };
        }
        return {
          slidesData: [
            {
              slideType: slideType,
              type: type,
              data: data,
              image: null,
              overallPerSelected,
              controlPerSelected,
              treatmentPerSelected,
              baselinePerSelected,
              progressPerSelected,
              diffPerSelected,
              showLables,
            },
          ],
        };
      });
    },
    setSlideDataArray: (data: any) => {
      set(() => ({
        slidesData: data,
      }));
    },
    resetStore: () => {
      set(() => ({
        selectedSlideType: 'Subject Wise',
        slidesData: [],
        saveData: null,
      }));
    },
    toggleReverseData: () => {
      set((state) => {
        return {
          isDataReverse: !state.isDataReverse,
        };
      });
    },
  };
});
